import { Component, OnInit } from '@angular/core';
import { SharedService } from './shared.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  allStats: any
  payments: any;
  customers: any;
  duePayments: any = [];
  isloading = true;
  user:any;

  constructor(
    private SharedService: SharedService
  ) { }

  ngOnInit(): void {

    this.user = this.SharedService.getUser();

    if(this.user.role === 'sales'){
      this.SharedService.salesDash().subscribe((data:any)=>{
        // console.log(data)
        this.allStats ={
          ctx: data.count.customers,
          leads: data.count.leads,
          properties: data.count.properties
        }

        this.customers = data.customers;

        data.duePayments.forEach(emi => {
          this.duePayments.push({
            pid:emi.customer.pid,
            name: emi.customer.name,
            contact_1: emi.customer.contact_1,
            type: emi.customer.payment_plan,
            amount: emi.emi_amount,
            payment_date: emi.emi_date
          })
        });

        this.isloading = false;
      })
    }else{
      this.SharedService.adminDash().subscribe((resp:any)=>{
        // console.log(resp)
        const stats = {}

        stats['all'] =resp.count.properties.all;
        stats['available'] = resp.count.properties.available;
        stats['sold'] = resp.count.properties.all-resp.count.properties.available;
        stats['customers'] = resp.count.customers;

        this.allStats = stats;
        this.customers = resp.customers

        resp.duePayments.forEach(emi => {
          this.duePayments.push({
            pid:emi.customer.pid,
            name: emi.customer.name,
            contact_1: emi.customer.contact_1,
            type: emi.customer.payment_plan,
            amount: emi.emi_amount,
            payment_date: emi.emi_date
          })
        });
        this.payments = resp.payments;
        this.isloading = false;
      });
    }

  }

}
